import { VIEWPORT_DIMENSIONS, VISUALIZATION_LAYOUT, ReplayTeamColors } from "@Components/game/session-results/feedback/visualization/constants";
import PlayerCircle from "@Components/game/session-results/feedback/visualization/player-circle";
import VisionCone from "@Components/game/session-results/feedback/visualization/vision-cone";
import { FieldPosition } from "@Containers/game/builder/models/builder-data-types";
import { fieldPositions } from "@Context/game/builder/builder-context";
import { Container, Text } from "@pixi/react";
import { useMemo } from "react";

interface IPlayer {
  character: any;
  showVisionCone: boolean;
  teamColors: ReplayTeamColors;
}

const getPositionFromJerseyNumber = (jerseyNumber: number): string => {
  const fieldPosition = fieldPositions.find((position: FieldPosition) => position.jerseyNumber === jerseyNumber);
  return fieldPosition ? fieldPosition.initials : "";
};

const Player = ({ character, showVisionCone, teamColors }: IPlayer) => {
  const isPlayerCharacter = character.isPlayer;
  const position = getPositionFromJerseyNumber(character.jerseyNumber);
  const textStyle = useMemo(
    () =>
      ({
        fontSize: Math.max(16 * VIEWPORT_DIMENSIONS.SCALE, 9),
        fill: "white",
        fontWeight: isPlayerCharacter ? "bold" : "normal",
      }) as any,
    [isPlayerCharacter]
  );

  return (
    <Container key={character.id} x={VISUALIZATION_LAYOUT.playerLayerOrigin.x + character.x} y={VISUALIZATION_LAYOUT.playerLayerOrigin.y + character.y}>
      {isPlayerCharacter && showVisionCone && <VisionCone rotation={character.rotation || 0} />}

      <PlayerCircle team={character.team} isPlayerCharacter={isPlayerCharacter} teamColors={teamColors} />

      <Text
        text={position}
        anchor={0.5}
        style={textStyle}
      />
    </Container>
  );
};

export default Player;
